import { Component, Input } from '@angular/core';
import { PetDto } from '../../services/service-proxy/service-proxies';
import { Recordatorio } from '../../services/pet-clinical.service';

/**
 * Tarjeta de mascota. La usan el resumen de la home y el listado completo, asi
 * que vive acá y no en ninguna de las dos: duplicarla las desincroniza al
 * primer ajuste de diseño.
 */
@Component({
  selector: 'app-pet-card',
  templateUrl: './pet-card.component.html',
  styleUrls: ['./pet-card.component.scss']
})
export class PetCardComponent {

  @Input() pet! : PetDto;

  /** Alterna el color de la foto, como en el prototipo. */
  @Input() indice = 0;

  /** "Ver su ficha" en el listado; en la home cambia segun el estado. */
  @Input() textoAccion = 'Ver su ficha';

  /**
   * Proxima vacuna/control real, traido de la API de Vet por el contenedor.
   * null cuando no hay recordatorios: en ese caso no se muestra tag (antes se
   * mostraba "Sin historia clinica", que era un estado inventado por posicion).
   */
  @Input() proximaVacuna? : Recordatorio | null;

  get inicial() : string {
    return (this.pet?.name ?? '?').trim().charAt(0).toUpperCase();
  }

  get raza() : string {
    return this.pet?.breed?.name ?? this.pet?.species?.name ?? '';
  }

  /**
   * Edad a partir de birthdate, que es lo unico real que hay. Bajo el año va en
   * meses: "1 año" para un cachorro de tres meses seria peor que no decirlo.
   */
  get edad() : string {

    if(!this.pet?.birthdate) return '';

    const nacimiento = this.pet.birthdate.toDate();
    const hoy = new Date();

    let meses = (hoy.getFullYear() - nacimiento.getFullYear()) * 12
              + (hoy.getMonth() - nacimiento.getMonth());

    if(hoy.getDate() < nacimiento.getDate()) meses--;

    if(meses < 0) return '';

    if(meses < 12)
      return meses === 1 ? '1 mes' : `${meses} meses`;

    const años = Math.floor(meses / 12);

    return años === 1 ? '1 año' : `${años} años`;
  }

  /** Raza y edad en una linea, salteando lo que falte. Ambos reales (PetDto). */
  get datosLinea() : string {
    return [ this.raza, this.edad ]
      .filter(x => x && x.length > 0)
      .join(', ');
  }
}
